import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common-service';

@Component({
  selector: 'app-redash-dashboard',
  templateUrl: './redash-dashboard.component.html',
  styleUrl: './redash-dashboard.component.scss'
})
export class RedashDashboardComponent{
  @ViewChild('iframeRef') iframeRef: ElementRef | any;
  redashUrl:any
  role:any
  user_id:any
  iframeurl:any
  sanitizedUrl
  loader: boolean=false;
  constructor(private sanitizer: DomSanitizer, private api:CommonService){
    this.redashUrl = environment.redashurl
    this.role = localStorage.getItem('role')
    this.user_id = localStorage.getItem('user_id')
    this.iframeurl = `https://proreports.oneclickcx.ai/public/dashboards/dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU?org_slug=default&refresh=600/&p_user_id=${this.user_id}` ;
    // this.iframeurl = `https://ocdev.oneclick.info:9008/public/dashboards/dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU?org_slug=default&refresh=600/&p_user_id=${this.user_id}` ;
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeurl);
  }
  RefreshDash(){
  let body=  {
      "AUTH_KEY": "dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU",
      "dashboardId": "dearMJ6i887Ua8asHRWP9LgNn1BwRtAxdwVJRuLU",
      "parameters": {
        "user_id":this.user_id
    }     
  }
  this.loader=true;
  this.api.postMethod('refresh-dashboard',body).subscribe({
    next:(data:any)=> {
      this.loader=false;
      location.reload();    
    },    
  error:(error:any)=>{
  }
  })
  
  }

}

